import PropTypes from 'prop-types';
import Button from 'Components/Atoms/Button/Button';
import Dialog from 'Components/Molecules/Dialog/Dialog';
import { useTranslation } from 'react-i18next';
import DeleteConfirmDialogContent from './DeleteConfirmDialogContent';

export default function DeleteConfirmDialog(props) {
    const { open, onClose, onSubmit, title, description, cta, error, icon, showCaptcha } = props;

    const { t } = useTranslation('common');

    return (
        <Dialog open={open} onClose={onClose} size="sm">
            {error && (
                <div className="py-8 md:py-10 px-2 md:px-6">
                    <div className="text-center flex flex-col items-center gap-3 mb-8">
                        <div className="flex justify-center mb-2">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="48"
                                height="48"
                                fill="none"
                                viewBox="0 0 48 48"
                            >
                                <path
                                    fill="#F44854"
                                    d="M24 3c11.598 0 21 9.402 21 21s-9.402 21-21 21S3 35.598 3 24 12.402 3 24 3m0 28.34a2.699 2.699 0 1 0 0 5.397 2.699 2.699 0 0 0 0-5.398m0-20.077a2.7 2.7 0 0 0-2.698 2.699v11.107a2.699 2.699 0 0 0 5.397 0V13.962A2.7 2.7 0 0 0 24 11.263"
                                ></path>
                            </svg>
                        </div>
                        <div className="text-xl font-semibold text-dark-blue">{error.title}</div>
                        <div className="text-gray-500 text-pretty text-lg">{error.description}</div>
                    </div>
                    <div className="flex justify-center gap-3">
                        <Button onClick={onClose}>{t('close')}</Button>
                    </div>
                </div>
            )}

            {!error && (
                <DeleteConfirmDialogContent
                    onClose={onClose}
                    onSubmit={onSubmit}
                    title={title}
                    description={description}
                    cta={cta}
                    icon={icon}
                    showCaptcha={showCaptcha}
                />
            )}
        </Dialog>
    );
}

DeleteConfirmDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    cta: PropTypes.string,
    error: PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
    }),
    icon: PropTypes.node,
    showCaptcha: PropTypes.bool,
};
